import React from 'react';
import { Task, TaskCreator } from 'components/Route/Task';
import { PageModuleActions, CourseActions } from 'actions';
import debounce from 'oxygen-debounce';

import PageModule from 'components/PageModule';

class TaskModule extends PageModule {
  state = {
    file: null,
  };

  setFile = (file) => {
    this.setState({ file });
  };

  save(task) {
    if (!task) {
      this.changeToDetailMode();
      return;
    }
    const { type, values, description } = task;
    const data = this.props.params;
    const items = [];
    const correctResponse = { value: [] };
    values.forEach((value, index) => {
      if (value.correct) {
        correctResponse.value.push(index);
      }
      items.push(value.text);
    });

    CourseActions.updateTask(this.props.moduleId, {
      id: data.taskId || data.task.taskId,
      caption: {
        main: description,
        items,
      },
      correctResponse,
      type,
    });
    return true;
  }

  saveCaption = (task, desc) => {
    const { type, values, description, comment } = task;
    const data = this.props.params;
    const items = [];
    const correctResponse = { value: [] };
    values.forEach((value, index) => {
      if (value.correct) {
        correctResponse.value.push(index);
      }
      items.push(value.text);
    });
    CourseActions.updateTaskComplete(this.props.moduleId, {
      id: data.taskId || data.task.taskId,
      caption: {
        main: desc || description,
        items,
        comment,
      },
      correctResponse,
      type,
    });
    CourseActions.updateTaskCaption({
      id: data.taskId || data.task.taskId,
      caption: {
        main: description,
        items,
        comment,
      },
      correctResponse,
      type,
    });
  };

  autoSave(task) {
    PageModuleActions.markModuleSaving(this.props.moduleId);
    if (this._saveTimer) {
      clearTimeout(this._saveTimer);
    }
    this._saveTimer = setTimeout(() => {
      this.save(task);
    }, 1000);
  }

  handleChange = debounce((...args) => {
    this.saveCaption(...args);
  }, 1000);

  componentWillUnmount() {
    // this.handleChange.clear();
  }

  renderEditMode(content, data) {
    const {
      moduleId,
      themeColor,
      isQuiz,
      pageRowId,
      data: { userdata },
      ...other
    } = this.props;
    data.task = data.task || {};
    data.task.caption = data.task.caption || {
      main: [this.context.getIntlMessage('tasks.description')],
    };
    data.task.caption.items = data.task.caption.items || [];
    return (
      <div {...other}>
        <TaskCreator
          themeColor={themeColor}
          onChange={this.handleChange}
          setFile={this.setFile}
          file={this.state.file}
          ref="creator"
          content={content}
          userdata={userdata}
          moduleId={moduleId}
          pageRowId={pageRowId}
          isQuiz={isQuiz}
          {...data.task}
        />
      </div>
    );
  }

  renderDetailMode(content, data) {
    const {
      moduleId,
      themeColor,
      reader,
      isQuiz,
      data: { userdata },
      ...other
    } = this.props;
    const canAnswer =
      (!this.props.editor &&
        data.task &&
        data.task.caption &&
        data.task.caption.main) ||
      this.props.reader;
    data.task = data.task || {};
    data.task.caption = data.task.caption || {
      main: [this.context.getIntlMessage('tasks.description')],
    };
    data.task.caption.items = data.task.caption.items || [];
    return (
      <div {...other}>
        <div>
          {content}
          <Task
            isQuiz={isQuiz}
            reader={reader}
            file={this.state.file}
            themeColor={themeColor}
            canGrade={!this.props.reader}
            pageModuleId={moduleId}
            userdata={userdata}
            {...data.task}
            taskResults={data.taskResults}
            canAnswer={canAnswer}
            name={this.props.name}
            pageId={this.props.pageId}
            courseId={this.props.courseId}
            gaTracking={this.props.gaTracking}
          />
        </div>
      </div>
    );
  }
}

export default TaskModule;



// WEBPACK FOOTER //
// ./src/js/components/Page/Module/Task.js